import { Injectable } from '@angular/core';
import moment from 'moment';

// INTERFACES
import { ICreditCard } from '../../../client/interfaces/client-payment-profile.interface';

@Injectable({
  providedIn: 'root',
})
export class CardUtilService {
  constructor() {}

  getLastDigitFormat(cardNumber :string) :string {
    const values = [...cardNumber.replace('XXXX', '')];
    values.splice(1, 0, ' ');

    return values.join('');
  }

  getExpirationDateFormat(data :{
    expirationMonth :string;
    expirationYear :string;
  }) :string {
    const { expirationMonth, expirationYear } = data;

    return `${expirationMonth}/${expirationYear.slice(-2)}`;
  }

  getFormattedCardInfo(data :{
    card :ICreditCard;
    cardType :string;
    businessAccountId :number;
    userId :number;
  }) :any {
    const { card, cardType, businessAccountId, userId } = data;
    const dates = card.expirationDate?.split(' / ');
    const month = dates && dates[0] ? dates[0] : '';
    let year = dates && dates[1] ? dates[1] : '';

    if (year.length === 2) {
      year = moment(dates && dates[1] ? dates[1] : '', 'YY').format('YYYY');
    }

    return {
      number: card.number.replace(/\s/g, ''),
      expirationMonth: month,
      expirationYear: year,
      type: cardType,
      cvv: card.cvv,
      label: card.label,
      firstName: card.firstName,
      lastName: card.lastName,
      address: card.address,
      zip: card.zip?.toString(),
      city: card.city,
      state: card.state,
      country: card.country,
      businessAccountId,
      userId,
    };
  }
}
